import styled from 'styled-components';
import { Button } from 'antd';

export const GoBackButton = styled(Button)`
  margin-bottom: 10px;
`;
